import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistAdminService from '../../services/artistAdminService.js';
import ArtistService from '../../services/artistService.js';
import pull from 'lodash/pull';
import ToastrService from '../../services/toastrService.js';
import * as browserCheck from '../../utils/browserCheck.js';

class Compose extends Component {
    constructor(props, context) {
        super(props, context);
        this.sendMessage = this.sendMessage.bind(this);
        this.recipientsSearch = this.recipientsSearch.bind(this);
        this.recipientsSelected = this.recipientsSelected.bind(this); 
        this.getRecipientsSelected = this.getRecipientsSelected.bind(this);
        this.getInitialState = this.getInitialState.bind(this);
        this.state = this.getInitialState();
    }
    
    getInitialState() {
        return {
            error: null,
            recipientsTypeaheadLoading: false,
            recipientsTypeaheadOptions: [],
            from: this.props.activeProfile.Username,
            to: this.props.to || [],
            subject: this.props.subject || '',
            body: ''
        };
    }

    componentDidMount() {  
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#frmSendMessage .getmdl-select');    
        }
    }

    componentWillUpdate(nextProps) {
        if(this.props.activeProfile !== nextProps.activeProfile) {
            this.setState({ from: nextProps.activeProfile.Username });
        }
    }

    sendMessage(event) {
        event.preventDefault();
        //what happens on profile page if we switch the active role? on the chat page, we might need to reload and also turn up, connections?
        if(!this.state.to.length) {
            this.setState({ error: 'Please enter a recipient'});
        }
        else if(!this.state.body && !this.state.body.trim()) {
            this.setState({ error: 'Please enter a message'});
        }
        else {
            const message = {
                fromRoleID: this.props.activeProfile.ID,
                toRoleIDs: this.state.to.map(t => t.ID),
                subject: this.state.subject,
                body: this.state.body,
                conversationID: this.props.conversationID
            };
            ArtistAdminService.sendMessage(this.props.activeProfile.ID, message)
                .then(result => {
                    const toastrService = new ToastrService();
                    if(result.Count < message.toRoleIDs.length) {
                        toastrService.showWarning('', `Your message has been sent, however we could only send it to ${result.Count} of the ${message.toRoleIDs.length} users specified`);
                    }
                    else {
                        toastrService.showSuccess('', 'Your message has been sent!');
                    }
                    if(this.props.sendCallback) {
                        this.props.sendCallback();
                    }
                    this.setState(this.getInitialState());
                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }
    }

    recipientsSearch(query) { 
        this.setState({recipientsTypeaheadLoading: true});
        ArtistAdminService.getMessageRecipients(this.props.activeProfile.ID, query)
            .then(items => {
                this.setState({
                    recipientsTypeaheadLoading: false,
                    recipientsTypeaheadOptions: items.map(i => this.formatRecipient(i))
                });
            });
    }

    recipientsSelected(items) {     
        let to = [...this.state.to];
        if(items.length < this.state.to.length) {
            //we've removed 1, remove it from the server and then from state
            const removedRecipient = this.state.to.find(r => !items.find(i => i.ID === r.ID));            
            pull(to, removedRecipient);
            this.setState({ to });
        }
        else {            
            //we've added 1, find the item
            const newItem = items.find(i => to.find(t => t.ID === i.ID) == null);            
            if(newItem) {
                if(newItem.SendEnabled) {
                    to.push(newItem);
                    this.setState({ to });
                }
                else {
                    const toastrService = new ToastrService();
                    toastrService.showError('', 'Sorry, you cannot send a message to this user');
                    //we're not making any changes but we update the state so that we re-render the autocomplete without the item
                    this.setState({ to });
                }
            }
        }
    }

    formatRecipient(recipient) {
        return Object.assign({}, recipient, {
            label: `${recipient.Username} (${recipient.DisplayName} - ${ArtistService.getRoleTypeFriendlyName(recipient.RoleType)})`,
            value: recipient.ID
       });
    }

    getRecipientsSelected() {
        //return the selected recipients in typeahead format
        const items = this.state.to.map(r => this.formatRecipient(r));
        return items;
    }
    
    render() {        
        return (
            <form id="frmSendMessage" className="form-regular" onSubmit={this.sendMessage} style={{paddingBottom: '15px'}}>
                <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty">
                    <input id="From" name="From" className="mdl-textfield__input" value={this.state.from} readOnly />
                    <label className="mdl-textfield__label" htmlFor="From">From</label>
                </div>
                <p className="grey visible-xs">To:</p>
                {
                    this.props.isReply || this.props.to ?
                        <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty">
                            <input id="To" name="To" className="mdl-textfield__input" value={this.props.to.map(t => t.Username).join(', ')} readOnly />
                            <label className="mdl-textfield__label" htmlFor="To">To</label>
                        </div>
                        : 
                        <div className="form-group form-multiselect" style={{ paddingLeft: 0 }}>
                            <div className="materialize-autocomplete mdl-textfield--floating-label mdl-block is-dirty" style={{ paddingBottom: 0 }}>
                                <AsyncTypeahead id="Recipients" multiple placeholder="Enter name" minLength={3} isLoading={this.state.recipientsTypeaheadLoading} onSearch={this.recipientsSearch} onChange={this.recipientsSelected} options={this.state.recipientsTypeaheadOptions} selected={this.getRecipientsSelected()} />
                                <label className="mdl-textfield__label" htmlFor="Recipients">To</label>
                            </div>
                        </div>
                }
                {
                    !this.props.isReply ?
                        <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block">
                            <input id="Subject" name="Subject" className="mdl-textfield__input" value={this.state.subject} onChange={(event) => this.setState({ subject: event.target.value })} maxLength={50} />
                            <label className="mdl-textfield__label" htmlFor="Subject">Subject</label>
                        </div>
                        : null
                }
                <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty" style={{width:'100%'}}>
                    <textarea className="mdl-textfield__input" cols="55" id="Body" name="Text" rows="5" value={this.state.body} onChange={(event) => this.setState({ body: event.target.value })} maxLength={1000} />                            
                    <label className="mdl-textfield__label" htmlFor="Body">Message</label>
                </div>
                <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-filter" value={this.props.isReply ? 'Send reply' : 'Send Message'} onClick={this.sendMessage} />
            </form>  
        );
    }
}

Compose.propTypes = {
    activeProfile: PropTypes.object.isRequired,
    to: PropTypes.array,
    subject: PropTypes.string,
    conversationID: PropTypes.number,
    sendCallback: PropTypes.func,
    isReply: PropTypes.bool
};

export default Compose;